import React, { useState } from "react";
import doubleAngleDown from "../../../../assets/double-angle-down.png";
import doubleAngleRight from "../../../../assets/double-angle-right.png";

const FaqNavContent = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [openQuestion, setOpenQuestion] = useState("data");

  const imgDownSymbol = (
    <img
      src={doubleAngleDown}
      alt="Down arrow"
      className="h-10 sm:h-10 md:h-8 cursor-pointer hover:scale-105 transition-transform duration-300"
    />
  );

  const imgRightSymbol = (
    <img
      src={doubleAngleRight}
      alt="Right arrow"
      className="h-10 sm:h-10 md:h-8 cursor-pointer hover:scale-105 transition-transform duration-300"
    />
  );

  const tabs = ["general", "how-to", "service", "payment", "refund", "return"];

  const toggleQuestion = (key) => {
    setOpenQuestion(openQuestion === key ? null : key);
  };

  return (
    <div className="min-h-screen sm:min-h-[10px] md:min-h-[100px] lg-xl:min-h-[150px] bg-white flex flex-col items-center py-28 sm:py-20 md:py-16 lg-xl:py-[60px] font-[Poppins] px-4 sm:px-6 sm:mb-[-4rem] md:mb-[-2.2rem] sm:mt-[-1.5rem] lg-xl:mt-[5px] xl-2xl:mt-[5px]  ">
      {/* Tabs */}
      <div className="w-full flex justify-start justify-center overflow-x-auto scrollbar-hide">
        <div
          className="
      flex bg-white rounded-full border border-gray-300 
      py-2 px-4 gap-4
      overflow-x-auto
      whitespace-nowrap scrollbar-hide
    "
        >
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`
          px-5 py-2.5 md:px-6 md:py-3 
          text-sm md:text-base 
          rounded-full 
          transition-all duration-300
          flex-shrink-0
          ${activeTab === tab
                  ? "bg-[#6E3FC6] text-white"
                  : "text-black hover:bg-gray-200"
                }
        `}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* FAQ Section */}
      <div className="w-full flex justify-center">
        <div className="w-full sm:w-auto overflow-x-auto">
          {
            <>
              {/* for General Tab */}
              <div>
                {activeTab === "general" && (
                  <div

                    className="w-full flex flex-col items-center space-y-4 py-10"
                  >
                    {/* Question 1 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("data")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          how does be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz keep my data secure?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "data"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "data" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz is a smart, all-in-one platform for restaurants,
                          cafés, fashion, retail and food businesses. It helps you
                          manage customers, orders, staff, and revenue in real
                          time, reducing waiting times and creating a faster,
                          smoother experience for both businesses and customers.
                        </p>
                      )}
                    </div>

                    {/* Question 2 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px]  max-w-full"
                      onClick={() => toggleQuestion("payment")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          is my payment information protected?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "payment"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "payment" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, your payment information is encrypted and securely
                          processed using industry-standard methods to ensure your
                          data remains safe.
                        </p>
                      )}
                    </div>

                    {/* Question 3 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("support")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          will my orders and queries get priority support?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "support"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "support" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          yes, all active users receive timely support. premium
                          users may get faster response times and priority
                          handling of urgent queries.
                        </p>
                      )}
                    </div>
                  </div>
                )
                }
              </div>

              {/* for how-to Tab */}
              <div>
                {activeTab === "how-to" && (
                  <div

                    className="w-full flex flex-col items-center space-y-4 py-10"
                  >
                    {/* Question 1 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("data")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          how does be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz keep my data secure? -: under construction
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "data"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "data" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz is a smart, all-in-one platform for restaurants,
                          cafés, fashion, retail and food businesses. It helps you
                          manage customers, orders, staff, and revenue in real
                          time, reducing waiting times and creating a faster,
                          smoother experience for both businesses and customers.
                        </p>
                      )}
                    </div>

                    {/* Question 2 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px]  max-w-full"
                      onClick={() => toggleQuestion("payment")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          is my payment information protected?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "payment"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "payment" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          yes, your payment information is encrypted and securely
                          processed using industry-standard methods to ensure your
                          data remains safe.
                        </p>
                      )}
                    </div>

                    {/* Question 3 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("support")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          will my orders and queries get priority support?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "support"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "support" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, all active users receive timely support. premium
                          users may get faster response times and priority
                          handling of urgent queries.
                        </p>
                      )}
                    </div>
                  </div>
                )
                }
              </div>

              {/* for service Tab */}
              <div>
                {activeTab === "service" && (
                  <div

                    className="w-full flex flex-col items-center space-y-4 py-10"
                  >
                    {/* Question 1 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("data")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          how does be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz keep my data secure? -: under construction
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "data"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "data" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz is a smart, all-in-one platform for restaurants,
                          cafés, fashion, retail and food businesses. It helps you
                          manage customers, orders, staff, and revenue in real
                          time, reducing waiting times and creating a faster,
                          smoother experience for both businesses and customers.
                        </p>
                      )}
                    </div>

                    {/* Question 2 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px]  max-w-full"
                      onClick={() => toggleQuestion("payment")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          is my payment information protected?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "payment"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "payment" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, your payment information is encrypted and securely
                          processed using industry-standard methods to ensure your
                          data remains safe.
                        </p>
                      )}
                    </div>

                    {/* Question 3 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("support")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          will my orders and queries get priority support?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "support"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "support" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, all active users receive timely support. premium
                          users may get faster response times and priority
                          handling of urgent queries.
                        </p>
                      )}
                    </div>
                  </div>
                )
                }
              </div>


              {/* for payment Tab */}
              <div>
                {activeTab === "payment" && (
                  <div

                    className="w-full flex flex-col items-center space-y-4 py-10"
                  >
                    {/* Question 1 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("data")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          how does be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz keep my data secure? -: under construction
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "data"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "data" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz is a smart, all-in-one platform for restaurants,
                          cafés, fashion, retail and food businesses. It helps you
                          manage customers, orders, staff, and revenue in real
                          time, reducing waiting times and creating a faster,
                          smoother experience for both businesses and customers.
                        </p>
                      )}
                    </div>

                    {/* Question 2 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px]  max-w-full"
                      onClick={() => toggleQuestion("payment")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          is my payment information protected?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "payment"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "payment" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, your payment information is encrypted and securely
                          processed using industry-standard methods to ensure your
                          data remains safe.
                        </p>
                      )}
                    </div>

                    {/* Question 3 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("support")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          will my orders and queries get priority support?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "support"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "support" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, all active users receive timely support. premium
                          users may get faster response times and priority
                          handling of urgent queries.
                        </p>
                      )}
                    </div>
                  </div>
                )
                }
              </div>


              {/* for refund Tab */}
              <div>
                {activeTab === "refund" && (
                  <div

                    className="w-full flex flex-col items-center space-y-4 py-10"
                  >
                    {/* Question 1 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("data")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          how does be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz keep my data secure? -: under construction
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "data"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "data" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz is a smart, all-in-one platform for restaurants,
                          cafés, fashion, retail and food businesses. It helps you
                          manage customers, orders, staff, and revenue in real
                          time, reducing waiting times and creating a faster,
                          smoother experience for both businesses and customers.
                        </p>
                      )}
                    </div>

                    {/* Question 2 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px]  max-w-full"
                      onClick={() => toggleQuestion("payment")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          is my payment information protected?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "payment"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "payment" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, your payment information is encrypted and securely
                          processed using industry-standard methods to ensure your
                          data remains safe.
                        </p>
                      )}
                    </div>

                    {/* Question 3 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("support")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          will my orders and queries get priority support?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "support"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "support" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, all active users receive timely support. premium
                          users may get faster response times and priority
                          handling of urgent queries.
                        </p>
                      )}
                    </div>
                  </div>
                )
                }
              </div>


              {/* for return Tab */}
              <div>
                {activeTab === "return" && (
                  <div

                    className="w-full flex flex-col items-center space-y-4 py-10"
                  >
                    {/* Question 1 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("data")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          how does be
                          <span className="inline-block scale-x-[-1] tracking-[0px]">
                            e
                          </span>
                          mz keep my data secure? -: under construction
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "data"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "data" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed lowercase">
                          be
                          <span className="inline-block scale-x-[-1] tracking-[0px] ">
                            e
                          </span>
                          mz is a smart, all-in-one platform for restaurants,
                          cafés, fashion, retail and food businesses. It helps you
                          manage customers, orders, staff, and revenue in real
                          time, reducing waiting times and creating a faster,
                          smoother experience for both businesses and customers.
                        </p>
                      )}
                    </div>

                    {/* Question 2 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px]  max-w-full"
                      onClick={() => toggleQuestion("payment")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          is my payment information protected?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "payment"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "payment" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, your payment information is encrypted and securely
                          processed using industry-standard methods to ensure your
                          data remains safe.
                        </p>
                      )}
                    </div>

                    {/* Question 3 */}
                    <div
                      className="bg-[#F8F5FC] rounded-xl p-6 shadow cursor-pointer transition-all w-[900px] max-w-full"
                      onClick={() => toggleQuestion("support")}
                    >
                      <div className="flex justify-between items-center">
                        <p className="font-semibold text-gray-800 text-base lowercase">
                          will my orders and queries get priority support?
                        </p>
                        <span className="text-xl text-[#6B3EF5]">
                          {openQuestion === "support"
                            ? imgDownSymbol
                            : imgRightSymbol}
                        </span>
                      </div>
                      {openQuestion === "support" && (
                        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                          yes, all active users receive timely support. premium
                          users may get faster response times and priority
                          handling of urgent queries.
                        </p>
                      )}
                    </div>
                  </div>
                )
                }
              </div>

            </>
          }
        </div>
      </div>
    </div>
  );
};


export default FaqNavContent;